<template>
    <div class="home">
        <Header></Header>

        <div class="bg-notebook position-relative">
            <div class="container py-5">
                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="w-60">
                            <p class="txt-h-6 txt-black">
                                BEM-VINDO AO <span class="txt-cores-1">SOLLICITA CAPACITAÇÃO</span>
                            </p>
                            <p class="txt-h-3 txt-blue-2">
                                Aqui você terá conteúdo
                                educacional exclusivo
                                do <span class="txt-cores-1">Sollicita PRO</span>
                            </p>
                            <p class="txt-h-6 txt-black txt-w-4">
                                Somos o maior portal de conteúdo especializado em licitações e contratos do Brasil, e agora a escola mais completa do país. São mais de 1.000 aulas gravadas que te ensinarão compras públicas, licitação, pregão, contratos, patrimônio público, governança, terceirização, controle interno, e muito mais!
                            </p>
                            <button class="btn btn-yellow w-100" @click="showModalCadastro = !showModalCadastro">
                                QUERO CONHECER
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="onda">
                <!--<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 400"><path fill="#0C1C25" fill-opacity="1" d="M0,96L60,85.3C120,75,240,53,360,53.3C480,53,600,75,720,106.7C840,139,960,181,1080,181.3C1200,181,1320,139,1380,117.3L1440,96L1440,320L1380,320C1320,320,1200,320,1080,320C960,320,840,320,720,320C600,320,480,320,360,320C240,320,120,320,60,320L0,320Z"></path></svg>-->
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="" >
                                <span class="txt-h-6 txt-w-8 txt-cores-1">
                                    CURSOS E ESTANTE
                                </span>
                                <p class="txt-h-3 txt-w-8 txt-cores-1">
                                    Conheça alguns dos cursos
                                </p>
                                <p class="txt-h-6 txt-w-6 txt-white w-50">
                                    São mais de 1000 aulas de oficinas, palestras, cursos, aulas ao vivo e exclusivas para atender as suas principais necessidades de capacitação e de desenvolvimento. Você precisa aprender do zero? Precisa se especializar na fase interna? Precisa se capacitar em pontos polêmicos de licitações e contratos? Quer se profissionalizar e ganhar segurança para trabalhar com eficiência e autonomia? Temos a solução certa para você.
                                </p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="w-100 bg-blue-metade">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-4 mt-2 mt-md-0" v-for="(item,index) in lstCursos" :key="index">
                        <div class="box-curso-exclusivo">
                            <div class="marcador h-100" v-if="item.flCursoSollicita">
                                <div class="conteudo-marcador txt-white txt-h-6 txt-size-10 txt-white text-center w-50 m-auto mt-3">
                                    Curso Exclusivo
                                    <i class="fa-solid fa-ticket-simple"></i>
                                </div>
                            </div>
                            <img class="rounded img-curso mb-2" :src="(item.urlImagemCapa==null?'img-default-curso.png':item.urlImagemCapa)" onerror="this.onerror=null; this.src='/img-default-curso.png'" />
                            <p class="txt-h-6 txt-size-16 txt-w-7 txt-blue-1 mb-2 reduz-texto-2" style="height: 40px">
                                {{item.nmTreinamento}}
                            </p>
                            <p class="txt-l txt-size-14 txt-w-5 txt-grey-3 mb-3 reduz-texto-4" style="height: 84px">
                                {{item.dsTreinamento}}
                            </p>
                            <div class="d-grid py-3">
                                <router-link class="btn bg-cores-2 txt-white" :to="{name:'Curso', params:{id:item.idTreinamento}}">
                                    Quero esse curso
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
        <div class="container mt-5">
            <div class="row justify-content-center ">
                <div class="col-6">
                    <router-link class="btn btn-yellow txt-blue-1 w-100" :to="{name:'Estante'}">
                        Ver mais cursos na estante de cursos
                    </router-link>
                </div>
            </div>
        </div>

        <!-- VANTAGENS -->
        <div class="vantagens mt-5">
            <div class="titulo-vantagens">
                <div class="divisor-icone d-flex bd-highlight align-items-center">
                    <div class="divisor-horizontal" style="border-top: 2px solid #0C1C25; width: 16vw;" ></div>
                    <div class="d-flex align-items-center mx-3">
                        <span class="txt-h-2 txt-blue-2 txt-size-20">
                            VANTAGENS
                        </span>
                    </div>
                    <div class="divisor-horizontal flex-grow-1 " style="border-top: 2px solid #0C1C25 "></div>
                </div>
            </div>
            <div class="container mt-2">
                <div class="row">
                    <div class="col-12 mt-4" v-for="(item,index) in lstVantagens" :key="index">
                        <div class="box-vantagens">                            
                            <span class="icone-box" :style="{color: item.iconColor}"><i :class="item.icon"></i></span>
                            <p class="txt-p txt-blue-1 txt-size-16 txt-w-5 mb-0" v-html="item.dsVantagem">
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container mt-5">
                <div class="row">
                    <div class="col-12 col-md-6">
                        <p class="txt-p txt-size-16 txt-grey-3 txt-w-4 mb-0 w-70">
                            O Sollicita PRO sempre esteve a frente e atento as necessidades e exigências de capacitação dos órgãos de controle para todos aqueles que atuam com licitações e contratos, por isso desenvolveu a mais completa ferramenta de capacitação continuada para seus assinantes. Os assinantes do Sollicita PRO têm acesso imediato e irrestrito a todo conteúdo de capacitação formulado pelo Grupo Negócios Públicos.
                            Agora essa ferramenta cresceu ainda mais, tonando-se assim uma <span class="txt-bold">escola completa de estudos </span>para todos aqueles que desejam se desenvolver e ter segurança na tomada de decisões.
                        </p>
                    </div>
                    <div class="col-12 col-md-6 mt-3 mt-md-0 bg-blue-1 d-flex align-items-center justify-content-center rounded">
                        <div class="text-center w-50">
                            <p class="txt-p txt-size-20 txt-w-4 txt-cores-1 mb-0">Com tantas vantagens,</p>
                            <p class="txt-p txt-size-20 txt-w-7 txt-cores-1 mb-0">
                                o que você está esperando?
                            </p>
                        </div>
                    </div>
                </div>
                <div class="row mt-4">
                    <div class="col-12">
                        <div class="d-grid">
                            <button class="btn btn-yellow txt-blue-1"  @click="showModalCadastro = !showModalCadastro">Quero começar meus cursos agora mesmo!</button>
                        </div>
                        
                    </div>
                </div>
            </div>
        </div>

        <!-- PLATAFORMA E LOJA -->
        <div class="plataforma my-5 position-relative">
            <div class="container mb-3">
                <div class="row text-center">
                    <span class="txt-h-6 txt-blue-1 txt-w-8">
                        PLATAFORMA E LOJA
                    </span>
                </div>
                <div class="row">
                    <div class="col-12 col-md-8 pe-0">
                        <img class="img-fluid position-relative" style="z-index: 2;" src="../assets/img/notebook-monitor.png" width="850" height="699" />
                    </div>
                    <div class="col-12 col-md-4 ps-0 d-flex">
                        <div class="dados-plataforma mt-5 d-flex flex-column">
                            <div class="position-relative mb-5">
                                <div class="bg-blue-1 txt-h-3 txt-cores-1 txt-w-8 rounded-end px-5 py-2 mb-5 position-absolute text-center" style="left:-60px; z-index: 1; width: calc(100% + 60px);">Plataforma 100% online</div>
                            </div>
                            
                            <p class="txt-p txt-size-20 txt-grey-3 text-end ps-5 mt-5">
                                Assista no computador, no tablet, no celular, ou em outros aparelhos, a qualquer hora e em qualquer lugar. Você pode ainda baixar o app  exclusivo no seu android ou ios. Não existem mais desculpas para não começar agora. A sua capacitação continuada está a um clique. Faça parte da maior comunidade de especialistas em licitações e contratos.
                            </p>

                            <div class="d-grid ps-5 mt-5">
                                <button class="btn btn-yellow txt-blue-1"  @click="showModalCadastro = !showModalCadastro">Cadastrar grátis agora</button>
                            </div>
                        </div>
                        
                    </div>
                </div>
                <div class="row mt-5">
                    <div class="col-12 col-md-4 pe-0 d-flex">

                        <div class="dados-plataforma mt-5 d-flex flex-column">
                            <div class="position-relative mt-5 mb-5">
                                <div class="d-none d-sm-block bg-cores-1 txt-h-3 txt-blue-1 txt-w-8 rounded-start px-5 py-2 mb-5 position-absolute text-center" style="right:-43px; z-index: 1; width: calc(100% + 60px);">
                                    Cursos exclusivos
                                </div>
                                <div class="d-block d-sm-none bg-cores-1 txt-h-3 txt-blue-1 txt-w-8 rounded-start px-5 py-2 mb-5 position-absolute text-center">
                                    Cursos exclusivos
                                </div>
                            </div>
                            
                            <p class="txt-p txt-size-20 txt-white text-start mt-5 pe-5">
                                Além de ter acesso a cursos, aulas, eventos e seminários gravados, nossos novos assinantes participam de um curso intensivo ao vivo, exclusivo, onde podem tirar dúvidas com os maiores especialistas convidados, interagir, fazer networking em um ambiente fechado e seguro.
                            </p>

                            <div class="d-grid pe-5 mt-5">
                                <router-link class="btn btn-yellow txt-blue-1" :to="{name:'Estante'}">
                                    Quero visitar a loja
                                </router-link>
                            </div>
                        </div>
                        
                    </div>
                    <div class="col-12 col-md-8 ps-0 ">
                        <img class="img-fluid position-relative" style="z-index: 2;"  src="../assets/img/notebook-livro.png" width="850" height="699" />
                    </div>
                </div>
            </div>
           
            <!-- CATEGORIAS -->
            <div class="box-categorias">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-12 col-md-5">
                            <div class="cursos-categoria text-center">
                                <span class="txt-h-6 txt-size-14 txt-cores-1">CURSOS E CATEGORIAS</span>
                                <p class="txt-h-3 txt-blue-1 ">
                                    Procure cursos por categoria
                                </p>

                                <div class="position-relative d-flex justify-content-center w-100">
                                    <div class="lista-caregorias d-flex">
                                        <div class="item-categoria txt-white bg-negocios zoom">
                                            <i class="icon fa-solid fa-scale-balanced mb-2"></i>
                                            <span class="txt-p txt-w-7">
                                                Nova Lei de Licitações
                                            </span>
                                        </div>
                                        <div class="item-categoria txt-white bg-marketing zoom">
                                            <i class="icon fa-solid fa-gavel mb-2"></i>
                                            <span class="txt-p txt-w-7">
                                                Pregão
                                            </span>
                                        </div>
                                        <div class="item-categoria txt-white bg-tecnologia zoom">
                                            <i class="icon fa-solid fa-building-columns mb-2"></i>
                                            <span class="txt-p txt-w-7">
                                                Estatais
                                            </span>
                                        </div>
                                        <div class="item-categoria txt-white bg-desenvolvimento zoom">
                                            <i class="icon fa-solid fa-s mb-2"></i>
                                            <span class="txt-p txt-w-7">
                                                Sistema S
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="d-grid mt-5">
                                <button class="btn btn-yellow txt-blue-1"  @click="showModalCadastro = !showModalCadastro">CRIAR CONTA E ACESSAR CURSOS</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="space-box-categorias mb-4"></div>

        <ModalCadastro  :showModal="showModalCadastro" ></ModalCadastro>

        <Footer class="mt-5"></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Header';
    import Footer from '@/components/Footer'
    import ModalCadastro from '@/components/ModalCadastro'

    import { urlApi, avisoErro } from '@/config/global'
    import axios from 'axios'

    export default {
        name: 'Home',
        components: { Header, Footer, ModalCadastro },
        props: {
            msg: String
        },
        data: function () {
            return {
                lstCursos: [],

                lstVantagens: [
                    { id: 1, icon: 'fa-solid fa-flag', iconColor: '#DCBB5F', dsVantagem: 'Os melhores especialistas: assista onde e quando quiser.'},
                    { id: 2, icon: 'fa-solid fa-video', iconColor: '#E0675F', dsVantagem:'Live: Aulas ao vivo.'},
                    { id: 3, icon: 'fa-solid fa-envelope', iconColor: '#74B3ED', dsVantagem: 'Materiais e apostilas exclusivos: acesso imediato a todo conteúdo.'},
                    { id: 4, icon: 'fa-solid fa-desktop', iconColor: '#A27DD1', dsVantagem: 'Acesso a avaliação dos usuários: garantia de qualidade e tradição do Grupo Negócios Públicos.'},
                    { id: 5, icon: 'fa-solid fa-cart-shopping', iconColor: '#8AC566', dsVantagem: '+ de 600 h de capacitação: o melhor custo-benefício do mercado.'},
                ],

                showModalCadastro: false,
            }
        },
        methods: {
            load() {
                this.getCursos();
            },

            getCursos() {
                let $this = this;
                axios.get(`${urlApi}/Treinamento/GetPrincipais`, { params: { take: 1, index: 0, flComImagem: true, flCursoCapacitacao: true} })
                    .then(res => {
                        if (res.data.success) {
                            if (res.data.data.rows != null) {
                                $this.lstCursos = [];
                                for (let i = 0; i < (res.data.data.rows.length > 3 ? 3 : res.data.data.rows.length); i++) {
                                    let item = res.data.data.rows[i].treinamento;
                                    item.flCursoSollicita = true;
                                    $this.lstCursos.push(item);
                                }

                            }
                        } else {
                            avisoErro("Não foi possível carregar os cursos");
                            $this.lstCursos = [];
                        }
                    })
                    .catch(function () {
                        avisoErro("Não foi possível carregar os cursos");
                        $this.lstCursos = [];
                    });
            },
        },
        mounted: function () {
            this.load();
        },
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .bg-notebook {
        background-image: url('../assets/img/bg-home.png');
        background-repeat: no-repeat;
        background-position: right top;
        /*background-position: left top;*/
        background-size: initial;
        padding: 20px 0 0 0;
        background-color: #f3f0f1;
    }

    .onda {
        width: 100%;
        position: relative;

        background-image: url('../assets/img/onda.png');
        background-repeat: no-repeat;
        background-position: top center;
        background-size: initial;

        padding: 5rem 0;

        svg {
            background-color: transparent;
        }
    }

    .bg-blue-metade {
        background: linear-gradient(to bottom, #0C1C25 50%, #FFF 50%);
    }

    .box-curso-exclusivo {
        padding: 20px;
        background: #FFF;
        box-shadow: 0px 5px 50px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        position: relative;

        height: 500px;

        .img-curso {
            width: 100%;
            height: 230px;
        }

        .marcador {
            background-image: url('../assets/img/tag.png');
            background-repeat: no-repeat;
            background-position: top center;
            background-size: initial;
            position: absolute;
            top: 0;
            left: 30px;

            .conteudo-marcador {
                display: flex;
                flex-direction: column;
                padding-left: 10px;
                align-items: center;
            }
        }
    }

    .box-vantagens {
        background: #E6E6E6;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        padding: 20px 50px;
        position: relative;

        .icone-box{
            position: absolute;
            top: -20px;
            left: -3px;

            font-size: 25px;
        }
    }

    .plataforma {
        width: 100%;
        position: relative;
        background-color: #FBFBFB;
        background-image: url('../assets/img/onda-lateral.png');
        background-repeat: no-repeat;
        background-position: left top;
        background-size: cover;
        padding: 5rem 0;
    }

    .box-categorias{
        position: absolute;
        width: 100%;
    }

    .space-box-categorias {
        height: 45vh
    }

    .cursos-categoria {
        background: #FFFFFF;
        box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.25);
        border-radius: 10px;
        padding: 30px 20px;

        .position-relative {
            height: 15vw;

            .lista-caregorias {
                position: absolute;

                .item-categoria {
                    display: flex;
                    justify-content: center;
                    align-content: center;
                    flex-direction: column;
                    padding: 15px;
                    background-color: #dedede;
                    width: 15vw;
                    height: 15vw;

                    .icon {
                        font-size: 3vw;
                    }

                    span {
                        font-size: 1vw;
                    }
                }

                .bg-negocios {
                    background: #DD4D4D;
                }

                .bg-marketing {
                    background: #9CD564;
                }

                .bg-tecnologia {
                    background: #5CB2D7;
                }

                .bg-desenvolvimento {
                    background: #7E4DCF;
                }
            }
        }
    }

    @media (max-width: 1730px) {
        .bg-notebook {
            background-position: left top;
        }
                
    }

    @media (max-width: 575.98px) {
        .cursos-categoria {
            .position-relative {
                height: 20vw;

                .lista-caregorias {
                    .item-categoria {
                        width: 22vw;
                        height: 22vw;

                        .icon {
                            font-size: 3vw;
                        }

                        span {
                            font-size: 2vw;
                        }
                    }
                }
            }
        }


        .space-box-categorias {
            height: 30vh
        }
    }
</style>

